/* eslint key-spacing: 'off', comma-spacing: 'off' */

export default {
    getVariables: function () {
        return [
            ['<nextLocation>', 'Click "Next" to choose one or more locations'],
            ['<crosstabLink>', 'For more information click here...']
        ]
    },
    getText: function (state) {
        switch (state.step) {
            case 'years':
                if (!state.justSelectedYear)
                    return [
                        'Start building your logistic regression model by selecting one or more years.',
                        'You may choose to analyze a <b> Single Year</b> of data, <b>Combine</b> two or more years of data, or <b>Compare</b> data across two or more years.',
                        'Clear the logistic regression model at any time by clicking the "Reset" button to the left.',
                        '<crosstabLink>',
                        'YR010'
                    ]
                if (state.singleYearSelected)
                    return [
                        'You have chosen to analyze a single year of data. ', 'Click "Next" to choose one or more locations.',
                        'YR020'
                    ]
                if (state.combiningYears)
                    return [
                        'You have chosen to combine multiple years of data for your analysis. ',
                        'Click "Next" to choose one or more locations.',
                        'YR030'
                    ]
                if (state.comparingYears)
                    return [
                        'You have chosen to compare across multiple years of data. ',
                        'Because you have chosen to <b>Compare Years</b>, you must choose <b>"Year"</b> as an independent variable in the following steps.',
                        'Click "Next" to choose one or more locations.',
                        'YR040'
                    ]
                break;
            case 'location':
                if (!state.justSelectedLocation)
                    return [
                        'Select one or more locations. ',
                        'You may choose to analyze a <b>Single Location</b> of data, to <b>Combine</b> data from two or more states, or to <b>Compare</b> data across two or more states. ',
                        'LOC010'
                    ]
                if (state.singleLocationSelected)
                    return [
                        'You have chosen to analyze data from a single location. ',
                        'Click "Next" to choose a row variable or click "Back" to change your year selection.',
                        'LOC020'
                    ]
                if (state.combiningLocations)
                    return [
                        'You have chosen to combine data from multiple states. ',
                        'Click "Next" to choose a row variable or click "Back" to change your year selection.',
                        'LOC030'
                    ]
                if (state.comparingLocations)
                    return [
                        'You have chosen to compare data across multiple states. ',
                        'Because you have chosen to <b>Compare States</b>, you must choose <b>"Location"</b> as an independent variable in the following steps.',
                        'Click "Next" to choose a row variable or click "Back" to change your year selection.',
                        'LOC040'
                    ]
                break;
            case 'selectDependentVariable':
                if (!state.isDependentSelected)
                    return [
                        'Select the dependent variable. ',
                        'A dependent variable is affected by one or more independent variables. For example, general health is known to be affected by age. Therefore, health may be a dependent variable in some analyses.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your location selection.',
                        'DEP040'
                    ]
                return [
                    'You have selected a dependent variable. ',
                    'Click "Next" to select your independent variable or click "Back" to change your location selection.',
                    'DEP070'
                ]
            case 'selectIndependentVariables':
                //Should we have separate help descriptions when state.anyIndependentSelected and when not selected for comparing locations or years
                if (state.comparingYears && state.comparingLocations && !state.anyIndependentIsYear && !state.anyIndependentIsLocation)
                    return [
                        'Since you are comparing years and locations, you must select year and location as independent variables. Optional: Select one or more topics as your independent variable(s). ',
                        'To select a variable, choose the topic in the drop down menu and click “Add.” Variables may be removed at any time by highlighting the variable and clicking “Remove” or by clicking “Remove All.”',
                        'An independent variable affects the independent variable.For example, general health is known to be affected by age.Therefore, age may be an independent variable in some analyses.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your dependent variable selection.',
                        'IND010'
                    ]
                if (state.comparingYears && state.comparingLocations && !state.anyIndependentIsYear && state.anyIndependentIsLocation)
                    return [
                        'Because you have selected to compare across years, you must select year as an independent variable. Optional: Select one or more topics as your independent variable(s).',
                        'To select a variable, choose the topic in the drop down menu and click “Add.” Variables may be removed at any time by highlighting the variable and clicking “Remove” or by clicking “Remove All.”',
                        'An independent variable affects the independent variable.For example, general health is known to be affected by age.Therefore, age may be an independent variable in some analyses.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your dependent variable selection.',
                        'IND020'
                    ]
                if (state.comparingYears && state.comparingLocations && state.anyIndependentIsYear && !state.anyIndependentIsLocation)
                    return [
                        'Because you have selected to compare across locations, you must select location as an independent variable. Optional: Select one or more topics as your independent variable(s).',
                        'To select a variable, choose the topic in the drop down menu and click “Add.” Variables may be removed at any time by highlighting the variable and clicking “Remove” or by clicking “Remove All.”',
                        'An independent variable affects the independent variable.For example, general health is known to be affected by age.Therefore, age may be an independent variable in some analyses.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your dependent variable selection.',
                        'IND030'
                    ]
                if (state.comparingYears && !state.anyIndependentIsYear)
                    return [
                        'Since you are comparing across years, you must select year as an independent variable. Optional: Select one or more topics as your independent variable(s).',
                        'To select a variable, choose the topic in the drop down menu and click “Add.” Variables may be removed at any time by highlighting the variable and clicking “Remove” or by clicking “Remove All.”',
                        'An independent variable affects the independent variable.For example, general health is known to be affected by age.Therefore, age may be an independent variable in some analyses.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your dependent variable selection.',
                        'IND040'
                    ]
                if (state.comparingLocations && !state.anyIndependentIsLocation)
                    return [
                        'Because you have selected to compare across locations, you must select location as an independent variable. Optional: Select one or more topics as your independent variable(s).',
                        'To select a variable, choose the topic in the drop down menu and click “Add.” Variables may be removed at any time by highlighting the variable and clicking “Remove” or by clicking “Remove All.”',
                        'An independent variable affects the independent variable.For example, general health is known to be affected by age.Therefore, age may be an independent variable in some analyses.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your dependent variable selection.',
                        'IND060'
                    ]
                if (state.comparingYears && state.comparingLocations)
                    return [
                        'You have selected year and location to be independent variables. Optional: Select one or more topics as your independent variable(s).',
                        'To select a variable, choose the topic in the drop down menu and click “Add.” Variables may be removed at any time by highlighting the variable and clicking “Remove” or by clicking “Remove All.”',
                        'An independent variable affects the independent variable.For example, general health is known to be affected by age.Therefore, age may be an independent variable in some analyses.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your dependent variable selection.',
                        'IND060'
                    ]
                if (state.anyIndependentIsLocation)
                    return [
                        'You have selected location as an independent variable. Optional: Select one or more topics as your independent variable(s)',
                        'To select a variable, choose the topic in the drop down menu and click “Add.” Variables may be removed at any time by highlighting the variable and clicking “Remove” or by clicking “Remove All.”',
                        'An independent variable affects the independent variable.For example, general health is known to be affected by age.Therefore, age may be an independent variable in some analyses.',
                        getVariableSelectCaveat(state),
                        'Click "Next" to select your optional control variables or click "Back" to change dependent row variable selection.',
                        'IND100'
                    ]
                if (state.anyIndependentIsYear)
                    return [
                        'You have selected year as an independent variable. Optional: Select one or more topics as your independent variable(s)',
                        'To select a variable, choose the topic in the drop down menu and click “Add.” Variables may be removed at any time by highlighting the variable and clicking “Remove” or by clicking “Remove All.”',
                        'An independent variable affects the independent variable.For example, general health is known to be affected by age.Therefore, age may be an independent variable in some analyses.',
                        getVariableSelectCaveat(state),
                        'Click "Next" to select optional control variables or click "Back" to change your dependent variable selection',
                        'IND080'
                    ]
                if (!state.anyIndependentSelected)
                    return [
                        ' Select one or more topics as your independent variable(s). To select a variable, choose the topic in the drop down menu and click “Add.” Variables may be removed at any time by highlighting the variable and clicking “Remove” or by clicking “Remove All.”',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection(s) or click "Back" to change your dependent variable selection.',
                        'IND090'
                    ]
                if (state.anyIndependentSelected)
                    return [
                        'You have selected an independent variable. You may select additional independent variables or click “Next” to select your reference categories.',
                        'Click "Back" to change your row variable selection.',
                        'IND110'
                    ]
                return [
                    'IND120'
                ]
            case 'setReference':
                return [
                    'Select your reference category for your dependent and independent variables. The reference category will be used as the default category for the logistic regression.',
                    'REF010'
                ]
            case 'viewreport':
                return [
                    'The results of your logistic regression are below.',
                    'To reset your selections, click the "Reset" button to the left.',
                    'To modify the statistical output on this results page, click "Modify" to make different selections on the previous screen.',
                    'Download and save the results of your logistic regression to Excel by clicking the "Download Results" link to the left."',
                    'REP010'
                ]
        }
        return [];
    }

}

function getVariableSelectCaveat(state) {
    if (state.combiningYears || state.comparingYears)
        return 'The variables listed are only the variables for the years selected';
    else
        return '';
}
